<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_14552_755"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_14552_755)">
      <path
        d="M16 10.5V13.25C16 15.1356 16 16.0784 15.4142 16.6642C14.8284 17.25 13.8856 17.25 12 17.25H5.875C4.83947 17.25 4 16.4105 4 15.375V15.375C4 14.3395 4.83947 13.5 5.875 13.5H12C13.8856 13.5 14.8284 13.5 15.4142 12.9142C16 12.3284 16 11.3856 16 9.5V7.75C16 5.86438 16 4.92157 15.4142 4.33579C14.8284 3.75 13.8856 3.75 12 3.75H8C6.11438 3.75 5.17157 3.75 4.58579 4.33579C4 4.92157 4 5.86438 4 7.75V15.375"
        stroke="url(#paint0_linear_14552_755)"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M7.75 7.5L12.25 7.5"
        stroke="url(#paint1_linear_14552_755)"
        stroke-width="1.5"
        stroke-linecap="round"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #437be8;
}
.v-list-item--active svg .stroke {
  stroke: #437be8;
}
</style>
